import { useQuery } from '@tanstack/react-query';
import { api } from '~/services/api';

export const usePricingSuggestion = (merchantId, categoryId, brand, material) => {
  return useQuery({
    queryKey: ['pricingSuggestion', merchantId, categoryId, brand, material],
    queryFn: () => {
      const params = new URLSearchParams({ category_id: categoryId });
      if (brand) params.set('brand', brand);
      if (material) params.set('material', material);

      return api.get(`/v1/${merchantId}/pricing/suggest/?${params}`).then((res) => {
        if (res.success) {
          return res.data;
        }
        // eslint-disable-next-line no-console
        console.warn('[usePricingSuggestion] API returned non-success response:', res);
        return null;
      });
    },
    enabled: !!merchantId && !!categoryId,
    retry: false,
    // Same param combo never needs re-fetching within a session — the pricing
    // engine is deterministic for a given (category, brand, material) tuple.
    staleTime: Infinity,
  });
};
